<template>
  <article class="editorial-article">
    <BlogHeading
      editorial
      :cypress-version="doc.cypressVersion"
      :playwright-version="doc.playwrightVersion"
      :vitest-version="doc.vitestVersion"
      :webdriverio-version="doc.webdriverioVersion"
      :cursor-version="doc.cursorVersion"
      :date="doc.date"
      :title="doc.title"
      :description="doc.description"
      :image="doc.image"
      :reading-time="doc.readingTime?.text"
    />
    <details v-if="tocLinks.length" class="mobile-toc" data-testid="mobile-toc">
      <summary data-testid="mobile-toc-toggle">
        Table of contents
        <span aria-hidden="true">↓</span>
      </summary>
      <ul>
        <li v-for="link in tocLinks" :key="link.id">
          <a :href="`#${link.id}`" :data-testid="`mobile-toc-link-${link.id}`">{{ link.text }}</a>
        </li>
      </ul>
    </details>
    <div class="article-reading-layout">
      <div class="article-reading-column">
        <ContentRenderer :value="doc" class="editorial-prose" data-testid="blog-content" />
        <BlogShareLinks :blog-info="doc" />
      </div>
      <BlogSidebar :links="tocLinks">
        <BlogUpcomingWorkshops />
        <BlogLatestBlogPost />
      </BlogSidebar>
    </div>
  </article>
</template>
<script setup lang="ts">
import type { Article } from '~/types/article'
const props = defineProps<{ doc: Article }>()
const tocLinks = computed(() => props.doc.body?.toc?.links || [])
if (props.doc) {
  defineOgImage({
    component: 'OgImageBlog',
    alt: props.doc.title,
    title: props.doc.title,
    image: props.doc.image,
    readingTime: props.doc.readingTime?.text || ''
  })

  useHead({
    title: props.doc.title,
    meta: [
      {
        property: 'og:url',
        content: `https://filiphric.com/${props.doc.slug}`
      },
      {
        property: 'og:type',
        content: 'article'
      },
      {
        property: 'og:title',
        content: props.doc.title
      },
      {
        property: 'og:description',
        content: props.doc.description
      },
      {
        property: 'twitter:card',
        content: 'summary_large_image'
      },
      {
        property: 'twitter:creator',
        content: '@filip_hric'
      },
      {
        property: 'twitter:title',
        content: props.doc.title
      },
      {
        property: 'twitter:description',
        content: props.doc.description
      },
      {
        property: 'article:published_time',
        content: props.doc.date
      },
      {
        property: 'article:author',
        content: 'Filip Hric'
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: `https://filiphric.com/${props.doc.slug}`
      }
    ]
  })
}
</script>
